/**
 * Meldingsbalk
 * Closing the bar writes a cookie holding the message hash, so the server skips
 * rendering it on the next page load and the bar returns as soon as the notice
 * text changes.
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $ } from "@utils/dom";
const COOKIE_NAME = "adurolight_notice";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
export const initNotificationBar = () => {
    const bar = $(".notification-bar");
    if (!bar) {
        return;
    }
    const close = $(".notification-bar__close", bar);
    const noticeId = bar.dataset.noticeId;
    if (!close || !noticeId) {
        return;
    }
    close.addEventListener("click", () => {
        document.cookie = `${COOKIE_NAME}=${encodeURIComponent(noticeId)}; path=/; max-age=${COOKIE_MAX_AGE}; samesite=lax`;
        bar.remove();
    });
};
